import RegisterAsInvestor from "./components/registerPages/RegisterAsInvestor.js";
import SignIn from "./components/SignIn.js";
import React from "react";
import ReactCmsEditor from "./components/Editor/ReactCmsEditor.js";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./components/HomeComponents/Home.js";
import Login from "./components/Login/Login.js";
import StartUpDetails from "./components/StartUpDetails.js";
import NavigationBar from "../src/components/HomeComponents/Navbar.js";
import MyFooter from "../src/components/HomeComponents/Footer.js";
import UserType from "./components/Login/UserType.js";
import InvestmentOption from "./components/InvestmentOption.js";
import LayoutOld from "./components/Layout/Layout.js";
import StartUpMainComponent from "./components/Layout/startupMainComponent.js";
import InvestorLayout from "./components/Layout/InvestorLayout.js";
import StartupListing from "./components/Investor/StartupListing.js";
import InvestorNavigationBar from "./components/HomeComponents/investorNavBar.js";
import MyWatchlist from "./components/Investor/Watchlist.js";
import DiscoverPage from "./components/Investor/discoverPage.js";
import NotFound from "./common/components/NotFound.js";
import { useLocation } from "react-router-dom";
import DealDetails from "./components/dealDetails.js";
import AllNotifications from "./components/companyWall/AllNotifications.js";
import { onForegroundMessage} from "./firebase.js";
import { Toaster, toast } from "react-hot-toast";

function App() {

  const routesWithLayout = ['/editor', '/investmentOption', '/investorRegister', '/userType', "/startUp"];
  const routesWithInvestment = ['/discover', '/investor', '/startUpDetails', "/watchlist", "/invest", "/portfolio", "/allstartups"];
  const requiresInvestNav = (pathname) => {
    return routesWithInvestment.includes(pathname);
  };

  const userType = {
    1: '/investorRegister?level=0',
  }


  const requiresLayout = (pathname) => {
    return routesWithLayout.includes(pathname);
  };
  const routeToLogin = () => {
    window.location.href = '/';
  }

  const authenticate = localStorage.getItem("authenticate");
  const accessToken = localStorage.getItem("accessToken")

  const IsUserRegistered = ({children}) => {
    const allData = localStorage.getItem("AllData")
    let parsed = JSON.parse(allData)

    if(parsed?.registrationStep <= 2){
       return children
    }else{
        window.location.href = "/discover"
        return
    }
  }
 
  const PrivateRoute = ({ children }) => {
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search)
    const paramName = queryParams.get("token")
   
    if (accessToken) {
      return children
    }
    else if (paramName && !accessToken) {
      window.location.href = "/"
    }
    else if (!paramName && !accessToken) {
      window.location.href = `${process.env.REACT_APP_LANDING_PAGE_URL}?type=investor&logout=true`
    }
  };

  const RouteToHome = ({ children }) => {
    const userData = localStorage.getItem("AllData")
    let parsed = JSON.parse(userData)
    const isAuthenticated = authenticate;

    if (isAuthenticated === 'true') {
      if (parsed?.registrationStep > 2) {
         return children
        } else {
          return window.location.href = parsed != null ? userType[parsed?.userType] : "/investorRegister?level=0";
      }
    }
    else {
      return children
    }
  }

  const IsStartUpVerified = ({ children }) => {
    const startupInfo = localStorage.getItem("startUpInfo")
    let parsedStartupInfo = JSON.parse(startupInfo)
    const location = useLocation()
    const path = location.pathname;
    const routePath = [0, 1, 2, 3, 4, 9]

    if (parsedStartupInfo.documentStatus === 7 || parsedStartupInfo.documentStatus === 8 || parsedStartupInfo.documentStatus === 10) {
      return children

    }
    else if (parsedStartupInfo.documentStatus === 5 && path != '/docSubmit') {
      return window.location.href = "/docSubmit"
    }
    else if (parsedStartupInfo.documentStatus === 6 && path != '/getDocs') {
      return window.location.href = "/getDocs"
    }
    else if (routePath.includes(parsedStartupInfo.documentStatus) && path != '/underProcess') {
      return window.location.href = "/underProcess"

    }
    else {
      return children
    }
  }

  return (
    <BrowserRouter>
      {requiresLayout(window.location.pathname) && <NavigationBar />}
      {requiresInvestNav(window.location.pathname) && <InvestorNavigationBar />}
      <Routes>
       
        <Route path="/" element={
          // <IsUserRegistered>
           <Login />
          //  </IsUserRegistered>
        } />
        <Route path="signin" element={<SignIn />} />
        <Route
          path="investorRegister"
          element={
            // <RouteToHome>
              <PrivateRoute>
                <IsUserRegistered>
                {" "}
                <RegisterAsInvestor />
                </IsUserRegistered>
                {" "}
              </PrivateRoute>
            //  </RouteToHome>
          }
        />
        <Route
          path="editor"
          element={
            <PrivateRoute>
              {" "}
              <ReactCmsEditor />
            </PrivateRoute>
          }
        />
        <Route
          path="startUpDetails"
          element={
            <PrivateRoute>
              <RouteToHome>
              <StartUpDetails /> 
              </RouteToHome>
            </PrivateRoute>
          }
        />
        <Route
          path="AllNotification"
          element={
            <PrivateRoute>
               <RouteToHome>
              <AllNotifications />
              </RouteToHome>
            </PrivateRoute>
          }
        />
        {/* <Route
          path="dealDetails"
          element={
            <PrivateRoute>
              <IsStartUpVerified>
                <LayoutOld>
                  <DealDetails />
                </LayoutOld>
              </IsStartUpVerified>
            </PrivateRoute>
          }
        /> */}
        {/* <Route
          path="userType"
          element={
            <PrivateRoute>
              <UserType />
            </PrivateRoute>
          }
        /> */}
        {/* <Route
          path="investmentOption"
          element={
            <PrivateRoute>
              <InvestmentOption />
            </PrivateRoute>
          }
        /> */}
        <Route
          path="investor"
          element={
            <PrivateRoute>
              <RouteToHome>
              <InvestorLayout />
              </RouteToHome>
            </PrivateRoute>
          }
        />
        {/* </Route> */}
        {/* <Route
          path="startUp"
          element={
            <PrivateRoute>
              <LayoutOld>
                <StartUpMainComponent />
              </LayoutOld>
            </PrivateRoute>
          }
        /> */}
        <Route
          path="allstartups"
          element={
            <PrivateRoute>
              <RouteToHome>
              <StartupListing />
              {/* <UnderProcess num={1} /> */}
              </RouteToHome>
            </PrivateRoute>
          }
        />
        <Route
          path="watchlist"
          element={
            <PrivateRoute>
             <RouteToHome>
              <MyWatchlist />
              {/* <UnderProcess num={1} /> */}
              </RouteToHome>
            </PrivateRoute>
          }
        />
        <Route
          path="discover"
          element={
            <PrivateRoute>
              <RouteToHome>
              <DiscoverPage />
              </RouteToHome>
             </PrivateRoute>
          }
        />
        {/* <Route
          path="invest"
          element={
            <PrivateRoute>
              <DiscoverPage />
            </PrivateRoute>
          }
        /> */}
      </Routes>
      {requiresLayout(window.location.pathname) && <MyFooter />}
      {requiresInvestNav(window.location.pathname) && <MyFooter />}
    </BrowserRouter>
  );
}

export default App;
